import React, { Fragment, useState } from "react";
import Image from "next/image";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { GetResourceResponseDto } from "@onair/repositories";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import EditIcon from "@mui/icons-material/Edit";
import ListItemText from "@mui/material/ListItemText";
import DeleteIcon from "@mui/icons-material/Delete";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";

interface LinkResourceItemProps {
	resource: GetResourceResponseDto;
	onDelete: (id: string) => void;
}

const MAX_NAME_FILE_LENGTH = 17;

const LinkResourceItem = ({ resource, onDelete }: LinkResourceItemProps) => {
	const { id, fileName, publicUrl } = resource;

	const [openDialog, setOpenDialog] = useState<boolean>(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleDeleteResource = (id: string) => {
		onDelete(id);
		handleClose();
		handleCloseDialog();
	};

	const handleCloseDialog = () => {
		setOpenDialog(false);
	};

	return (
		<Grid item xs={24} sm={12} key={id}>
			<Dialog
				open={openDialog}
				onClose={handleCloseDialog}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				maxWidth="xs"
				fullWidth
			>
				<DialogTitle id="alert-dialog-title">Xoá tệp</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{`Đường dẫn "${fileName}" sẽ bị xoá`}
						<br />
						Bạn có chắc chắn muốn tiếp tục
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button variant="outlined" onClick={handleCloseDialog} autoFocus>
						Huỷ
					</Button>
					<Button
						variant="contained"
						color="error"
						onClick={() => handleDeleteResource(id)}
					>
						Xoá
					</Button>
				</DialogActions>
			</Dialog>

			<Card
				variant="outlined"
				className=" p-2 rounded-md"
				sx={{
					backgroundColor: "#F4F6F8",
				}}
			>
				<Stack direction="row" justifyContent="space-between">
					<Stack direction="row" spacing={1.5} alignItems="center">
						<Box className=" w-6 h-6">
							<Image
								loading="lazy"
								src="/assets/icons/online-course/ic-link.svg"
								alt={`thumbnail ${id}`}
								width={24}
								height={24}
								className="object-cover h-full"
							/>
						</Box>

						<Tooltip title={fileName}>
							<Typography
								variant="body2"
								className="text-sm font-normal overflow-hidden text-ellipsis max-w-[200px] web break-words line-clamp-1"
							>
								{fileName.length > MAX_NAME_FILE_LENGTH
									? `${fileName.slice(0, MAX_NAME_FILE_LENGTH).trim()}...`
									: fileName}
							</Typography>
						</Tooltip>
					</Stack>
					<Box>
						<IconButton
							id={`resource-menu-button-${id}`}
							aria-label="options"
							onClick={handleClick}
							aria-haspopup="true"
							aria-controls={anchorEl ? "resource-menu" : undefined}
						>
							<MoreVertIcon />
						</IconButton>
					</Box>

					<Menu
						id="resource-menu"
						anchorEl={anchorEl}
						open={open}
						onClose={handleClose}
						MenuListProps={{
							"aria-labelledby": `resource-menu-button-${id}`,
						}}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "center",
						}}
						transformOrigin={{
							vertical: "top",
							horizontal: "left",
						}}
					>
						<MenuItem onClick={handleClose} className="mx-3">
							<ListItemIcon>
								<EditIcon className="mr-3" />
							</ListItemIcon>
							<ListItemText>Đổi tên</ListItemText>
						</MenuItem>
						<MenuItem onClick={() => setOpenDialog(true)} className="mx-3">
							<ListItemIcon>
								<DeleteIcon className="mr-3" />
							</ListItemIcon>
							<ListItemText>Xoá</ListItemText>
						</MenuItem>
					</Menu>
				</Stack>
			</Card>
		</Grid>
	);
};

export default LinkResourceItem;
